import React, { useState } from "react"
import { Container } from "reactstrap"

const PromoZones = props => {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <h4>Promo Zones (Ads) Management</h4>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default PromoZones
